// Shared wording for Pruning Queue flags (loop #5, same-week cohort rule).
// The backend writes the full plain-English explanation into `detail`; these
// helpers build the one-line summary and the badges both views show.

const money = (v) => `$${Math.round(Number(v || 0)).toLocaleString()}`;

const TEST_LABEL = {
  sales: 'Sales test',
  appointments: 'Appointment test',
  self_books: 'Self-book test',
};

export function testLabel(m = {}) {
  return TEST_LABEL[m.test] || 'Older rule';
}

// "4 sales vs ~14 expected · 3.5× the cost · luck under 0.1%"
export function flagSummary(m = {}) {
  if (!m.test) {
    // Flags recorded before the same-week rule shipped.
    return `cost ×${Number(m.cost_ratio || 0).toFixed(1)} · ${(Number(m.p_worse || 0) * 100).toFixed(0)}% confident`;
  }
  const plural = m.outcome_plural || 'outcomes';
  const cost = m.no_outcomes ? `no ${plural} at all` : `${Number(m.ratio || 0).toFixed(1)}× the cost`;
  const luck = Number(m.luck_chance || 0);
  const luckText = luck < 0.001 ? 'under 0.1%' : `${(luck * 100).toFixed(1)}%`;
  return `${Math.round(Number(m.actual || 0))} ${plural} vs ~${Number(m.expected || 0).toFixed(1)} expected · ${cost} · luck ${luckText}`;
}

export function spendLine(m = {}) {
  if (!m.test) return '';
  const peers = m.cohort === 'client' ? 'account' : 'ad set';
  return `${money(m.spend)} over ${m.weeks} wk · its ${peers} got one per ${money(m.peer_cost)}`;
}
